import moment from 'moment';

class EventService {

	isSalePossible(event, volatileTicketAvailability, selectedTicketsByPriceLevelUuid, anyShipmentAndPaymentPossible) {
		const totalAmountOfSelectedTickets = (Object.keys(selectedTicketsByPriceLevelUuid).length === 0) ? 0
		: Object.keys(selectedTicketsByPriceLevelUuid)
			.map(priceLevelUuid => selectedTicketsByPriceLevelUuid[priceLevelUuid])
			.reduce((accu, selectedPerPricelevel) => (accu + selectedPerPricelevel));

		const totalVolatileAvailability = (Object.keys(volatileTicketAvailability).length === 0) ? 0
		: Object.keys(volatileTicketAvailability)
			.map((categoryUuid) => volatileTicketAvailability[categoryUuid])
			.reduce((accu, availablePerCategory) => (accu + availablePerCategory));

		return (
			(event.lifecyclePhase === 'ON_SALE') &&
			((totalVolatileAvailability > 0) || !(totalAmountOfSelectedTickets === 0)) &&
			anyShipmentAndPaymentPossible
		);
	}

	areAllShipmentTypesExpired(event, bookingOffice) {
		const minHoursBefore = Math.min(
			...bookingOffice.activShipmentTypes.map(shipmentType =>
				bookingOffice.shipmentTypeAvailabilityInHours[shipmentType]
			)
		);

		const availableUntil = moment(event.begin).subtract(minHoursBefore, 'hours');
		const expired = moment() > availableUntil;

		return expired;
	}

	areAllPaymentTypesExpired(event, bookingOffice) {
		const minHoursBefore = Math.min(
			...bookingOffice.activPaymentTypes.map(paymentType =>
				bookingOffice.paymentTypeAvailabilityInHours[paymentType]
			)
		);

		const availableUntil = moment(event.begin).subtract(minHoursBefore, 'hours');
		const expired = moment() > availableUntil;

		return expired;
	}

	isPaymentTypeAvailable(paymentType, bookingOffice, begin) {
		const availabilityInHours = bookingOffice.paymentTypeAvailabilityInHours[paymentType];
		const availableUntil = moment(begin).subtract(availabilityInHours, 'hours');
		const active = bookingOffice.activPaymentTypes.indexOf(paymentType.toUpperCase()) !== -1;
		const expired = moment() > availableUntil;
		return !expired && active;
	}

	isAnyShipmentAndPaymentPossible(event, bookingOffice) {
		const anyShipmentTypeAvailable = !this.areAllShipmentTypesExpired(event, bookingOffice);
		const anyPaymentTypeAvailable = !this.areAllPaymentTypesExpired(event, bookingOffice);

		return (anyShipmentTypeAvailable && anyPaymentTypeAvailable);
	}
}
const eventService = new EventService();
export default eventService;
